import { useQuery } from '@tanstack/react-query';

import { roleApi } from '../api/role.adapter';

export const roleQueryKeys = {
  all: ['roles'] as const,
  list: () => [...roleQueryKeys.all, 'list'] as const,
  detail: (id: number) => [...roleQueryKeys.all, 'detail', id] as const,
};

export function useRolesQuery() {
  return useQuery({
    queryKey: roleQueryKeys.list(),
    queryFn: () => roleApi.listRoles(),
  });
}

export function useRoleQuery(id: number | null) {
  return useQuery({
    queryKey: id != null ? roleQueryKeys.detail(id) : ['roles', 'detail', 'disabled'],
    queryFn: () => roleApi.getRole(id as number),
    enabled: id != null,
  });
}
